<template>
  <div class="position-relative custom-image" :style="`width: ${width}px; height: ${height}px; min-width: ${width}px; min-height: ${height}px`">
    <img
      class="custom-image__blurhash"
      :class="{'custom-image__blurhash__hide': imageLoaded}"
      :src="blurDataUrl"
      alt="Blur placeholder"
      :width="width"
      :height="height"
      style="position: absolute; top: 0; left: 0; z-index: 1;"
    />
    <img
      :src="imageSrc"
      :alt="alt"
      :width="width"
      :height="height"
      @load="loadImage"
    />
  </div>
</template>

<script>
import { decode } from 'blurhash'

export default {
  props: {
    imageSrc: {
      type: String,
      default: '',
    },
    blurhash: {
      type: String,
      default: '',
    },
    width: {
      type: Number,
      default: 32,
    },
    height: {
      type: Number,
      default: 32,
    },
    alt: {
      type: String,
      default: '',
    },
    timeoutBlurHash: {
      type: Number,
      default: 300,
    },
  },
  data: () => ({
    blurDataUrl: '',
    imageLoaded: false,
  }),
  methods: {
    loadImage() {
      if (!this.blurhash) {
        this.imageLoaded = true
      }
      setTimeout(() => {
        this.imageLoaded = true
      }, this.timeoutBlurHash)
    },
    generateBlurDataUrl(blurhash) {
      const pixels = decode(blurhash, 32, 32)
      const canvas = document.createElement('canvas')
      canvas.width = 32
      canvas.height = 32
      const ctx = canvas.getContext('2d')
      const imageData = ctx.createImageData(32, 32)
      imageData.data.set(pixels)
      ctx.putImageData(imageData, 0, 0)
      return canvas.toDataURL()
    },
  },
  mounted() {
    if (!this.blurhash) {
      return
    }
    this.blurDataUrl = this.generateBlurDataUrl(this.blurhash)
  },
}
</script>

<style lang="scss">
.custom-image {
  border-radius: 4px;
  overflow: hidden;
  &__blurhash {
    transition: all 1s ease;
    opacity: 1;
    &__hide {
      opacity: 0;
      visibility: hidden;
    }
  }
}
</style>
